module.exports = __webpack_public_path__ + "img/policy-status.e40bfdfd.png";